import { z } from 'zod';
import { IObject } from './IObject';
import { IdSchema } from './IdSchema';
import { ROOT_ORGANIZATION_SETTINGS_ID } from './organizations/settings/organizationSettingsGroups';

// 'root' is reserved for the "(root) settings" defaults
// (/organizations/root/settings/*) — no organization may use it as an id or
// perciCode (see also syncPlatformOrganization, which refuses to write it).
const reservedIdMessage = `Organization id '${ROOT_ORGANIZATION_SETTINGS_ID}' is reserved`;

const isNotReserved = (value?: string | null) =>
  value !== ROOT_ORGANIZATION_SETTINGS_ID;

export const OrganizationSchema = z.object({
  id: IdSchema.refine(isNotReserved, reservedIdMessage),
  parentId: z.string().nullish(), // for hierarchical organizations
  name: z.string().min(1),
  perciCode: z.string().nullish().refine(isNotReserved, reservedIdMessage),
});

export type OrganizationData = z.infer<typeof OrganizationSchema>;
export type Organization = IObject.HasIdTimestamped<OrganizationData>;
